import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { routines as decisionsActions } from '../../reducers/db/decisions';
import './style.css';
import { routines as modalRoutines } from '../../reducers/ui/modal';
import FormButton from '../../components/shared/FormButton';
import TextArea from 'devextreme-react/text-area';

class CreateNegotiation extends Component {
  static propTypes = {
    className: PropTypes.string
  };
  static defaultProps = {
    className: ''
  };

  componentDidMount() {
    this.setState({ notes: '' });
  }

  handleSubmit = () => {
    if (this.state.notes === '' || this.state.notes === undefined) return;

    const { data } = this.props;

    this.props.createNegotiationHistory({
      QuestionId: data.questionId,
      LastModifiedByEmail: window.localStorage.getItem('active-user-id'),
      Notes: this.state.notes
    });
    this.handleCancel();
  };

  handleCancel = () => {
    this.props.closeModal();
  };

  handleChange = name => event => {
    this.setState({ [name]: event.value });
  };

  render() {
    const { className, data } = this.props;
    const classList = classNames('change-client-view', className);
    return (
      <div className={classList}>
        <div className="change-client-view-title">
          <i className="fas fa-building change-client-view-title-icon" />
          <span className="change-client-view-title-label">
            Create negotiation for {data.questionName}
          </span>
        </div>
        <div>
          <form onSubmit={this.handleSubmit}>
            <br />
            <div className="change-client-view-list">
              <div className="dx-fieldset-header">Notes</div>
              <TextArea
                height={90}
                maxLength={500}
                onValueChanged={this.handleChange('notes')}
                id="notes"
                name="notes"
              />
            </div>

            <br />
            <br />
            <div className="create-decisions-widget-footer">
              <FormButton primary type="submit" label="Create Negotiation" />
              <FormButton label="Cancel" onClick={this.handleCancel} />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const makeMapStateToProps = () => {
  const mapStateToProps = (state, props) => {
    return {};
  };
  return mapStateToProps;
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      createNegotiationHistory: decisionsActions.createNegotiationHistory,
      closeModal: modalRoutines.closeModal
    },
    dispatch
  );

export default connect(
  makeMapStateToProps,
  mapDispatchToProps
)(CreateNegotiation);
